import React, { useState, useMemo } from 'react'
import { withUserStore } from '../../../contexts/UserStore'
import { Button, Input } from '@byscott-io/corebyscott'
import Lex from '../../Shared/Lex'
import CommentThread from './CommentThread'
import TagSelector from '../../Shared/TagSelector'
// import {withCommentsApi} from "../../../apis/comments_api"
import TimeAgo from 'react-timeago'

const Comment = ({ isReply, comment, commentable, allComments, depth, userStore }) => {
  const [editing, setEditing] = useState(false)
  const [commentButton, setCommentButton] = useState(null)
  const label = isReply ? 'Reply' : 'Comment'

  // Filter replies to this comment. Declared before the early return below so the
  // hook is always called in the same order (react-hooks/rules-of-hooks).
  const replies = useMemo(() => {
    if (!allComments || !comment) return []
    return allComments.filter(c =>
      c.commentableType === 'Comment' &&
      c.commentableId === comment.id
    )
  }, [allComments, comment])

  // Safety check - if no comment data, return null
  if (!comment || !comment.id) {
    return null
  }

  const form = {}

  let accountsUser = null
  const getAccountsUser = () => {
    if (!accountsUser && comment.accountsUserId) {
      accountsUser = userStore.getAccountsUserById(comment.accountsUserId)
    }
    return accountsUser || {}
  }

  const formatWrittenAt = (date) => {
    return <TimeAgo date={date} />
  }

  const save = () => {
    const data = { ...comment, content: form.content.value }
    userStore.updateComment(data, () => setEditing(false))
  }

  const canEdit = comment?.permissions?.canUpdate !== false

  const handleEditClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setEditing(true)
  }

  const handleCancelClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setEditing(false)
  }

  // Create a commentable object with tags for TagSelector
  const commentAsTaggable = {
    ...comment,
    recordType: 'Comment'
  }

  const buttons = (
    <span className="inline-block" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {commentButton}
      <TagSelector taggable={commentAsTaggable} />
      {canEdit && !editing && (
        <span
          className="icon-button"
          style={{ cursor: 'pointer', display: 'inline-block' }}
          onClick={handleEditClick}
          title="Edit comment"
        >
          <i className="fas fa-pencil" />
        </span>
      )}
      {canEdit && editing && (
        <span
          className="icon-button"
          style={{ cursor: 'pointer', display: 'inline-block' }}
          onClick={handleCancelClick}
          title="Cancel edit"
        >
          <i className="fas fa-xmark" />
        </span>
      )}
    </span>
  )

  // <Container fluid={true} className="border1 rounded5px margin-bottom-5px">
  const commentDiv = () => {
    return (
      <div className="">
        <div className="size-75" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            {(() => {
              const user = getAccountsUser()
              const displayName = user?.nickname || user?.firstName || 'Unknown user'
              return String(displayName)
            })()} {commentable?.recordType === 'Comment' ? 'replied' : 'commented'} {formatWrittenAt(comment?.createdAt)}:
          </div>
          {buttons}
        </div>
        <div>
          {!editing && String(comment?.content || '')}
          {editing &&
            <>
              <div className="margin-bottom-5px size-90">
                <Input
                  type="textarea" innerRef={el => form.content = el} defaultValue={comment.content}
                  placeholder={label}
                />
              </div>
              <div className="text-right margin-bottom-5px size-90">
                <Button size="sm" color="success" onClick={save}><Lex term="save" /></Button>
              </div>
            </>}
        </div>
      </div>)
  }

  // Create a commentable object for this comment to enable nested replies
  const commentAsCommentable = {
    id: comment.id,
    recordType: 'Comment'
  }

  return (
    <div className="cbs-scope border1 rounded5px padding-5 margin5 margin-left-5px">
      {/* Always render CommentThread with content to show reply button at all depths */}
      <CommentThread
        depth={(depth || 0) + 1}
        isReply={true}
        thread={replies}
        allComments={allComments}
        commentable={commentAsCommentable}
        content={commentDiv()}
        onGetCommentButton={setCommentButton}
      />
    </div>)
}

export default withUserStore(Comment)
